import KeyValuePair, {getDefaultState as getDefaultStateKeyValuePair} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const RgaRecallStatus = t.struct({
    currentStatus: KeyValuePair,
    genericStatus: KeyValuePair,
    infoReqStatus: KeyValuePair,
    partReqStatus: KeyValuePair,
    photoReqStatus: KeyValuePair
}, 'RgaRecallStatus');

export const RgaSearchSelectedDomains = t.struct({
    analysisStatus: KeyValuePair,
    requesterType: KeyValuePair,
    rgaRecallStatus: RgaRecallStatus,
    rgaUnits: KeyValuePair
}, 'SelectedDomains');

export const getDefaultState = () => new RgaSearchSelectedDomains({
    analysisStatus: getDefaultStateKeyValuePair(),
    requesterType: getDefaultStateKeyValuePair(),
    rgaRecallStatus: new RgaRecallStatus({
        currentStatus: getDefaultStateKeyValuePair(),
        genericStatus: getDefaultStateKeyValuePair(),
        infoReqStatus: getDefaultStateKeyValuePair(),
        partReqStatus: getDefaultStateKeyValuePair(),
        photoReqStatus: getDefaultStateKeyValuePair()
    }),
    rgaUnits: getDefaultStateKeyValuePair()
});

export default RgaSearchSelectedDomains;



// WEBPACK FOOTER //
// ./src/rga/search/state/selected-domains.js